import { tJosa } from '@mathflat/shared/i18n/tJosa'

// worksheet, workbook 공통 사용
export const assignCancelWarning = {
  /** 기본: 보충학습지 언급 + 채점 보존 안내 */
  default: () => (
    <>
      <p>
        {tJosa('출제')} 취소 시 학생에게 {tJosa('출제')}된 내역과 학생앱에서 푼 보충학습지가
      </p>
      <p>모두 사라지며 다시 복구가 불가능합니다.</p>
      <p>{tJosa('출제')} 취소하시겠습니까?</p>
      <br />
      <p>(단, 유형분석의 채점 내역은 변경되지 않습니다.)</p>
    </>
  ),
  /** 수업 출제: 학습 기록 언급, 채점 보존 안내 없음 */
  forAssignedLecture: () => (
    <>
      <p>
        {tJosa('출제')} 취소 시 학생에게 {tJosa('출제')}된 내역과 학생앱에서 학습한 기록이
      </p>
      <p>모두 사라지며 다시 복구가 불가능합니다.</p>
      <p>{tJosa('출제')} 취소하시겠습니까?</p>
    </>
  ),
  /** 학원그룹교재: 단순 출제 내역 + 채점 보존 안내 */
  forAcademyGroupWorkbook: () => (
    <>
      <p>
        {tJosa('출제')} 취소 시 학생에게 {tJosa('출제')}된 내역이 모두 사라지며
      </p>
      <p>다시 복구가 불가능합니다. {tJosa('출제')} 취소하시겠습니까?</p>
      <br />
      <p>(단, 유형분석의 채점 내역은 변경되지 않습니다.)</p>
    </>
  ),
  /** 자동시험: 응시데이터 + 출제 이력 동시 삭제 안내 */
  forCas: () => (
    <>
      <p>
        {tJosa('출제')} 취소 시 학생의 응시데이터와 {tJosa('출제')}한 이력이
      </p>
      <p>모두 사라지며 다시 복구가 불가능합니다. {tJosa('출제')} 취소하시겠습니까?</p>
      <br />
      <p>(단, 유형분석의 채점 내역은 변경되지 않습니다.)</p>
    </>
  ),
  /** 입학고사 비재원생 배정 취소: 응시 데이터 + 출제 이력 동시 삭제 안내 */
  forEntranceTest: () => (
    <>
      <p>
        {tJosa('출제')} 취소 시 학생에게 {tJosa('출제')}된 이력과 응시 데이터가
      </p>
      <p>모두 사라지며 다시 복구가 불가능합니다.</p>
      <p>{tJosa('출제')} 취소하시겠습니까?</p>
    </>
  ),
  forExpiredEntranceTest: () => (
    <>
      <p>
        응시예정일이 지난 학생은 {tJosa('출제')} 취소 시 {tJosa('출제')}목록에서 노출되지 않습니다.
      </p>
      <p>{tJosa('출제')} 취소하시겠습니까?</p>
    </>
  ),
}
